import EmptyStateCompany from "components/emptyState";
import Tableinvoice from "components/table/tableinvoice";
import UseContext from "hooks/useContext";
import { useEffect, useState } from "react";
import { dateToEpoch } from "../../../../helper/helper";
import Pagination from "components/pagination/pagination";

const ToBeSetContent = () => {
  const { companyData } = UseContext();
  const dataInvoices = companyData.factures;
  const hasData = Object.keys(companyData).length > 0 && dataInvoices;
  const [arrayInvoices, setArrayInvoices] = useState([]);
  const [isWaiting, setIsWaiting] = useState(true); // Toujours true au départ pour éviter l'empty state
  const [currentPage, setCurrentPage] = useState(1);
  const countPerPage = 25;

  const titles = ["Mois", "Montant", "État", "Date"];

  useEffect(() => {
    if (dataInvoices instanceof Object || dataInvoices instanceof Array) {
      dataInvoices.sort(
        (a, b) =>
          dateToEpoch(new Date(a.date_facture)).getTime() -
          dateToEpoch(new Date(b.date_facture)).getTime()
      );
    }
  }, [dataInvoices]);

  useEffect(() => {
    if (!hasData) {
      setIsWaiting(true);
      setArrayInvoices([]);
      return;
    }
    
    setIsWaiting(true);
    setArrayInvoices([]); // Réinitialiser pour éviter l'empty state pendant le chargement
    const startTime = Date.now();
    const minLoadingTime = 200;
    
    let tampon = [];
    for (let m in dataInvoices) {
      if (!dataInvoices[m].status) {
        tampon.push({
          ...dataInvoices[m],
          fileName: `invoice_${companyData.id_bestt}_${dataInvoices[m].external_id}`,
        });
      }
    }
    
    const elapsedTime = Date.now() - startTime;
    const remainingTime = Math.max(0, minLoadingTime - elapsedTime);
    
    const timeoutId = setTimeout(() => {
      setArrayInvoices(tampon);
      setIsWaiting(false);
      setCurrentPage(1);
    }, remainingTime);
    
    return () => {
      clearTimeout(timeoutId);
    };
  }, [companyData._id, companyData.id_bestt]);

  const countTotal = arrayInvoices?.length || 0;
  const totalPages = Math.max(1, Math.ceil(countTotal / countPerPage));
  const paginatedInvoices = (arrayInvoices || []).slice(
    (currentPage - 1) * countPerPage,
    currentPage * countPerPage
  );

  return (
    <div className={"flex flex-col gap-8"}>
      {isWaiting ? (
        <Tableinvoice
          champsBody={[]}
          champsHeader={titles}
          isWaiting={true}
        />
      ) : (
        <>
          {arrayInvoices?.length ? (
            <>
              <Tableinvoice champsBody={paginatedInvoices} champsHeader={titles} isWaiting={false} />
              {countTotal > countPerPage && (
                <div className="flex-shrink-0 border-t border-gray-100 bg-white px-8 py-4">
                  <Pagination
                    currentPage={currentPage}
                    countPerPage={countPerPage}
                    countTotal={countTotal}
                    totalPages={totalPages}
                    setCurrentPage={setCurrentPage}
                  />
                </div>
              )}
            </>
          ) : (
            <EmptyStateCompany type={"invoices_nopay"} />
          )}
        </>
      )}
    </div>
  );
};

export default ToBeSetContent;
